.thumb {
    min-width: 650px;
    max-width: 1500px;
    flex-basis: 1;
    flex-grow: 1;

    height: 400px;
    padding: 30px;
    margin-left: 0;
    margin-right: 10px;
    background-color: white;
    border-radius: 20px;
    margin-bottom: 15px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
    &:hover {
        background-color: #e8f0fe;
    }
}

.imageThumbnailContainer {
    margin-left: 20px;
}

.imageThumbnail {
    width: 200px;
    height: calc(200 * 0.75);
    border-radius: 4px;
    transition: 0.3s;
}

.imageThumbLoading {
    width: 200px;
    height: calc(200px * 0.75);
    border-radius: 4px;
    border: 1px dashed #e0e0e0;
    background-color: white;
    position: absolute;
    z-index: 10000;
}

.score {
    position: absolute;
    top: 30px;
    right: 15px;
}

.overview {
    font-size: 16px;
    font-family: Hanken Grotesk;
    color: #475467;
}

.title {
    font-size: 24px;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #102442;
}

.industry {
    font-size: 16px;
    font-family: Hanken Grotesk;
    padding-bottom: 10px;
    color: #475467;
    max-width: calc(100% - 180px);
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
}

.fieldContainer {
    padding-right: 40px;
}

.fieldTitle {
    font-size: 18px;
    font-family: Hanken Grotesk;
    color: #98A2B3;
}

.fieldValue {
    font-size: 18px;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #475467;
}

.divider {
    width: calc(100% + 60px);
    height: 1px;
    border-bottom: 1px dashed #e0e0e0;
    margin-bottom: 15px;
    margin-left: -30px;
}
